import { TEST_ID_ROWS } from './rows-testids.js';
/** `area.component.part`, lower case, digits and hyphens. */
export const TEST_ID_PATTERN = /^[a-z0-9]+\.[a-z0-9-]+\.[a-z0-9-]+$/;
/** Every interactive surface a test may locate by test id, with its ARIA role. */
export const TEST_IDS = TEST_ID_ROWS;
/** `TEST_IDS` under the name the editor briefs import (DECISIONS 53 item 16): the same array. */
export { TEST_ID_ROWS };
const known = new Set(TEST_ID_ROWS.map((row) => row.id));
export function isTestId(value) {
    return typeof value === 'string' && known.has(value);
}
/** Spread onto an element: `<form {...tid('auth.login.form')}>`. An unknown id is a type error. */
export function tid(id) {
    if (!known.has(id))
        throw new RangeError(`unknown test id "${String(id)}"`);
    return { 'data-testid': id };
}
//# sourceMappingURL=testids.js.map